var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-subtitle-component" }, [
    _c("div", { staticClass: "row m-b-10" }, [
      _c(
        "div",
        {
          staticClass: "col-md-5 lang",
          class: [{ "l-selected": _vm.selected_lang }]
        },
        [
          _c("vue-select", {
            attrs: {
              placeholder: "lang",
              options: _vm.languages,
              label: "first_name",
              reduce: function(lang) {
                return lang
              }
            },
            model: {
              value: _vm.selected_lang,
              callback: function($$v) {
                _vm.selected_lang = $$v
              },
              expression: "selected_lang"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6 file" }, [
        _vm.selected_lang
          ? _c("div", [
              _vm.status === "INITIATED"
                ? _c("input", {
                    ref: "fileInput",
                    attrs: { type: "file", accept: _vm.formats },
                    on: {
                      change: function($event) {
                        return _vm.selectionProcessing($event)
                      }
                    }
                  })
                : _vm.status === "COMPLETE"
                ? _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        title: _vm.subtitle.origin_name,
                        href: _vm.subtitle.origin_s3_path
                      }
                    },
                    [_vm._v(_vm._s(_vm.subtitle.origin_name))]
                  )
                : _c("i", { staticClass: "fa fa-spin fa-spinner" })
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("i", {
          staticClass: "fa fa-trash remove-btn",
          on: {
            click: function($event) {
              return _vm.destroy_sub()
            }
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }